// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { RECURRING_FREQUENCY_UNITS, type RecurringOptions, numberToDayOfWeek } from '@seedplanner/shared-utils';

export default function formatRecurringFreq(recurringOptions: RecurringOptions): string {
  const result: string[] = [];
  for (const option of recurringOptions.frequencyGroups) {
    if (option.frequencyType === RECURRING_FREQUENCY_UNITS.DAYS) {
      result.push(
        `Every ${option.frequencies.length === 1 && option.frequencies[0] === 1 ? 'day' : `${option.frequencies.join(', ')} days`}`,
      );
    }
    if (option.frequencyType === RECURRING_FREQUENCY_UNITS.WEEKS) {
      result.push(
        `Every ${option.frequencies.length === 1 && option.frequencies[0] === 1 ? 'week' : `${option.frequencies.join(', ')} weeks`}`,
      );
    }
    if (option.frequencyType === RECURRING_FREQUENCY_UNITS.DAY_OF_WEEK) {
      result.push(`Every ${option.frequencies.map((f) => numberToDayOfWeek(f)).join(', ')}`);
    }
    if (option.frequencyType === RECURRING_FREQUENCY_UNITS.DAY_OF_MONTH) {
      result.push(`Every ${option.frequencies.map((f) => getOrdinal(f + 1)).join(', ')} days of month`);
    }
    if (option.frequencyType === RECURRING_FREQUENCY_UNITS.NTH_WEEKDAY_OF_MONTH) {
      const [targetWeekday, nthOccurrence] = option.frequencies;
      result.push(`Every ${getOrdinal(nthOccurrence + 1)} ${numberToDayOfWeek(targetWeekday)}`);
    }
  }

  return result.join('. ');
}

const getOrdinal = (n: number) => {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};
